import EditCategory from './edit_category'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getTranslatedCategoryList } from 'lib/category'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { combine, required } from 'lib/validators'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/edit_glimpse/edit_category')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  let validators = [required('category', i18n('category_required'))]

  return {
    validate: combine(...validators),
    initialValues: {
      category: campaign.category,
    },
    categoryList: getTranslatedCategoryList(state),
    campaignType: campaign.campaign_type,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { category: formValues.category })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_category',
    fields: ['category'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditCategory)
